import React from 'react';
import { StockChart, Tabs } from '@components';

function tabComp(props) {
  const {
    buyerName,
    targetName,
    selectedRange,
    changeRange,
    data: { buyer, target },
    defaultValue = 0,
    onTabChange,
    ...rest
  } = props;

  return (
    <Tabs
      className="stock-tab-wrapper"
      defaultValue={defaultValue}
      onChange={onTabChange}
      tabs={[
        {
          label: buyerName || '-',
          children: (
            <StockChart
              data={buyer}
              onRangeSelected={changeRange}
              selected={selectedRange}
              {...rest}
            />
          ),
        },
        {
          label: targetName || '-',
          children: (
            <StockChart
              data={target}
              onRangeSelected={changeRange}
              selected={selectedRange}
              {...rest}
            />
          ),
        },
      ]}
    />
  );
}

export default tabComp;
